module.exports = __webpack_public_path__ + "static/firstScreen-096887b09dd2c35219e6ee8786b8dcc3.jpg";